
export class InOutStock {
    inStock: number;
    outStock: number;

    constructor(inStock: number, outStock: number) {
        this.inStock = inStock || 0;
        this.outStock = outStock || 0;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/models/in-out-stock.ts